export enum StatisticsKeys {
  trafficPeak = 'trafficPeak',
  networksCount = 'networksCount',
  portsCount1G = 'portsCount1G',
  portsCount10G = 'portsCount10G',
  portsCount100G = 'portsCount100G',
  portsCount400G = 'portsCount400G',
}

export type Statistics = { [key in StatisticsKeys]: number };



// WEBPACK FOOTER //
// /www/client/src/containers/HomePage/Statistics/Statistics.ts